<template>
  <div class="results-filters">
    <label class="filter-group">
      <span class="filter-label">Forma de pago</span>
      <el-select
        :model-value="selectedPaymentMethod"
        @update:model-value="handleUpdatePaymentMethod"
        @change="emit('payment-method-change')"
        class="filter-select"
        size="default"
        popper-class="filter-select-dropdown"
        teleported
        :popper-options="popperOptions"
      >
        <el-option label="Contado" value="Contado" />
        <el-option label="Mensual" value="Mensual" />
        <el-option label="Semestral" value="Semestral" />
        <el-option label="Trimestral" value="Trimestral" />
      </el-select>
    </label>

    <div class="filter-group">
      <span class="filter-label">Plan</span>
      <el-segmented
        :model-value="selectedPlanType"
        @change="handlePlanTypeChange"
        :options="planTypeOptions"
        class="plan-type-segmented-lib"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface PlanTypeOption {
  label: string;
  value: string;
}

interface Props {
  selectedPaymentMethod: string;
  selectedPlanType: string;
  planTypeOptions: PlanTypeOption[];
}

defineProps<Props>();

const emit = defineEmits<{
  'update:selectedPaymentMethod': [value: string];
  'update:selectedPlanType': [value: string];
  'payment-method-change': [];
  'plan-type-change': [value: string | number | boolean];
}>();

const popperOptions = {
  placement: 'bottom-start',
  strategy: 'fixed',
  modifiers: [
    {
      name: 'computeStyles',
      options: {
        gpuAcceleration: false,
      },
    },
    {
      name: 'offset',
      options: {
        offset: [0, 4],
      },
    },
  ],
};

const handleUpdatePaymentMethod = (value: string): void => {
  emit('update:selectedPaymentMethod', value);
};

const handlePlanTypeChange = (value: string | number | boolean): void => {
  if (typeof value === 'string') {
    emit('update:selectedPlanType', value);
  }
  emit('plan-type-change', value);
};
</script>
